import { Box } from "@mui/material";
import { ITradeHistoryOrder } from "src/api/client/trade/trade-history.api.types";
import { Typography } from "src/components-mui/base/typography/typography";
import { useDateTimeFormatter } from "src/hooks/formatters/use-date-time-formatter";
import { isSameYear, isSameYearAndMonth } from "src/utils/date-util";

const TIME_SPAN_SX = { fontSize: "sm", fontWeight: "semibold", textAlign: "center" } as const;
const NO_WRAP_SX = { whiteSpace: "nowrap" } as const;

export const TimeSpan = ({ orders }: { orders: ITradeHistoryOrder[] }) => {
    const { formatMonthShort, formatMonthShortYear } = useDateTimeFormatter();

    const endDate = new Date(orders[0].executionDate);
    const startDate = new Date(orders[orders.length - 1].executionDate);

    if (isSameYearAndMonth(startDate, endDate)) {
        return <Box sx={TIME_SPAN_SX}>{formatMonthShortYear(endDate)}</Box>;
    }

    if (!isSameYear(startDate, endDate)) {
        return (
            <Box sx={TIME_SPAN_SX}>
                <Typography variant="inherit" component="span" sx={NO_WRAP_SX}>
                    {formatMonthShortYear(startDate)}
                </Typography>
                {" - "}
                <Typography variant="inherit" component="span" sx={NO_WRAP_SX}>
                    {formatMonthShortYear(endDate)}
                </Typography>
            </Box>
        );
    }

    return (
        <Box sx={TIME_SPAN_SX}>
            <Typography variant="inherit" component="span" sx={NO_WRAP_SX}>
                {formatMonthShort(startDate)}
            </Typography>
            {" - "}
            <Typography variant="inherit" component="span" sx={NO_WRAP_SX}>
                {formatMonthShortYear(endDate)}
            </Typography>
        </Box>
    );
};
